<template>

	<div class="certificate-list">
		<b-card bg-variant="light" text-variant="white" v-if="isExeption">
			<b-row>
				<b-col cols="3">
				<b-form-input id="name"
				v-on:keyup.enter="accept"
					v-model="filter.name"
					 name="name"
					 :placeholder="$t('section.create-section-type.name') +'/'+ $t('goods.artikul')"
				>
				</b-form-input>
			</b-col>
			<b-col cols="3">
				<b-form-input id="barcode"
				v-on:keyup.enter="accept"
				v-model="filter.barCode"
					name="barcode"
					:placeholder="$t('goods.barcode')"
				>
				</b-form-input>
			</b-col>
			<b-col><b-button
			style="color:white" @click="accept"
			class="pull-right" variant="primary">{{ $t('apply') }}
				</b-button></b-col>
			</b-row>
			<b-row
			:class="value.length>0?'p-3':'p-1'">
			<table class="table b-table table-striped" fixed size="xs" v-if="value.length>0">
			<thead>
			<tr>
				<th style="width: 3%;text-align: center">
					<vs-checkbox v-if="value.length>0" type='checkbox' @click='checkAll(value)' :key="isCheckAll"
									v-model="isCheckAll"></vs-checkbox>
				</th>
				<th style="width: 5%;text-align: center">№</th>
				<th class="alignedRight"
					style="width: 18%">
					{{$t('reference.name')}}
				</th>
				<th class="alignedRight"
					style="width: 6%">
					{{$t('goods.artikul')}}
				</th>

				<th style="width: 10%" class="alignedCenter">{{$t('goods.barcode')}}</th>
				<th style="width: 10%" class="alignedCenter">{{$t('goods.color')}}</th>
				<th style="width: 6%" class="alignedCenter">{{$t('goods.brand')}}</th>
				<th class="textAlignCenter" style="width: 4%">{{$t('sale.kol-vo')}}</th>
				<!--<th class="alignedRight" style="width: 12%">Кол-во Транзакции</th>-->
				<!-- <th v-if="isAdmin" class="textAlignCenter" style="width: 8%">{{ $t('prices.item.sum') }}</th> -->
				<th v-if="isAdmin && checkSaleType == 'WHOLE'" class="textAlignCenter" style="width: 13%">{{
					$t('prices.item.lastPriceWholesale') }}
				</th>
				<th v-if="isAdmin && checkSaleType == 'RETAIL'" class="textAlignCenter" style="width: 10%">{{ $t('prices.item.sum-new') }}
				</th>


			</tr>
			</thead>
			<tbody>

			<tr v-for="(item, index) in value" :key="index"
			:class="[item.isItemDublicate? 'table-warning' : '']"
				:id="'tooltip-target' + item.itemId">
				<!--<td>{{name}}</td>-->
				<td style="text-align: center">
					<vs-checkbox type="checkbox"
									:id="item.itemId"
									:vs-value="item"
									:disabled="item.isItemDublicate"
									v-model="checkedItems"/>

				</td>
				<td style="text-align: center">
				<strong>{{index+1}}</strong>
				</td>
				<td>{{item.itemName}}
				<td>{{item.artikul}}
				</td>

				<!--<td>{{value[value.length-1].maxValue}}</td>-->
				<td>{{item.barcode}}</td>
				<td>{{item.colorName}}</td>
				<td>{{item.brand}}</td>
				<td style="text-align: center">{{item.inventory}}</td>

				<!-- <td v-if="isAdmin" style="text-align: center">{{item.incomeUzs| currency({
					symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',
					thousandsSeparator: ' '
					})}}
				</td> -->
				<td v-if="isAdmin && checkSaleType == 'WHOLE'" style="text-align: center">{{item.priceWholesale| currency({
					symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',
					thousandsSeparator: ' '
					})}}
				</td>
				<td v-if="isAdmin &&  checkSaleType == 'RETAIL'" style="text-align: center">{{item.priceUzs| currency({
					symbol: value.currencyName, fractionCount: 2, symbolPosition: 'back',
					thousandsSeparator: ' '
					})}}
				</td>

				<b-tooltip
				v-if="item.isItemDublicate"
				:target="'tooltip-target' + item.itemId" triggers="hover">
				Цены на этот товаров не равны, пожалуйста, сравните цены
				</b-tooltip>
			</tr>
			<tr v-if="value.items">
				<td v-if="value.items.length==0" colspan="11"><h4 style="text-align: center">Пока
					нет
					доступных данных</h4>
				</td>
			</tr>
			</tbody>

			</table>
		</b-row>
		<b-row v-if="value.length>0">
			<b-col>
				<b-button class="mr-2" variant="success"
				 @click="addItemForExeption">{{$t('client.addClient') }}</b-button>
				<!-- <b-button variant="danger" @click="deleteItemForExeption">{{$t('promo-to-product.delete-item') }}</b-button> -->
			</b-col>
		</b-row>
		</b-card>
		<b-row class="mb-3">
			<b-col cols="4">
				<multiselect
					v-model="department"
					:options="listWarehouse"
					:multiple="false"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-col>
			<div class="spinner-wrapper" v-if="loader">
				<div class="spinner-grow text-success " role="status">
					<span class="sr-only"></span>
				</div>
				<div class="spinner-grow text-danger" role="status">
					<span class="sr-only"></span>
				</div>
				<div class="spinner-grow text-primary" role="status">
					<span class="sr-only"></span>
				</div>

			</div>
			<b-col cols="1">
				<b-button size="sm" variant="primary" @click="viewItems"><i class="fa fa-eye" aria-hidden="true"
																			style="font-size: 20px;cursor: pointer"></i>
				</b-button>
			</b-col>
			<b-col class="pl-0 ml-0" cols="6">
				<b-button size="sm" @click="viewExeptions" variant="warning">
					<i class="fa fa-plus" aria-hidden="true"
					style="font-size: 20px;cursor: pointer; color:white"></i>
				</b-button>
			</b-col>
			<!-- <b-col>
				<b-input :placeholder="$t('goods.barcode') +' / '+ $t('goods.artikul')"></b-input>
			</b-col> -->
			<b-modal size="xl" v-model="viewModal" :title="$t('sidebar.warehouse-management.product-view')" hide-footer>
				<view-request></view-request>
			</b-modal>

			<table class="table table-bordered mt-3" style="margin-right: 10px;margin-left: 10px;">
				<thead>
				<tr>
					<th style="width: 30px;text-align: center">№</th>
					<th>{{$t('sidebar.warehouse-management.products')}}</th>
					<th style="width: 120px;text-align: center">{{$t('goods.barcode')}}</th>
					<th>{{$t('incomes.balance')}}</th>
					<th>{{$t('incomes.balance')}}</th>
					<th style="width: 120px;text-align: center">{{$t('goods.amount')}}</th>
					<th style="width: 200px;text-align: center">{{$t('comment')}}</th>
					<th class="text-center">{{$t('prices.item.actions')}}</th>
					<!--<th style="width: 230px;">Количество</th>-->
				</tr>
				</thead>
				<tr v-for="lostItem,index in itemsForModal" cols="12">
					<td style="text-align: center">
						{{ index + 1 }}
					</td>
					<td>{{lostItem.itemName?lostItem.itemName:lostItem.name}}/ <strong>{{ lostItem.artikul}}</strong>/{{lostItem.colorName}}
					</td>
					<td style="text-align: center">	<strong>{{lostItem.barcode}}</strong></td>
					<td style="text-align: center">
						{{lostItem.inventory}}
						<!-- {{ lostItem.balance>=0?lostItem.balance:lostItem.inventory }} -->
					</td>
					<td style="text-align: center">
						{{lostItem.balance}}
					</td>
					<td>
						<b-col>
							<b-input-group size="sm" :class="{ss:lostItem['count']> lostItem.balance}">
								<b-form-input v-model="lostItem['count']"
											  size="sm" autocomplete="off" type="number"></b-form-input>
								<!-- <b-input-group-addon> -->
									<!-- <b-button size="sm" disabled>
										{{ lostItem.unitName }}
									</b-button> -->
								<!-- </b-input-group-addon> -->
							</b-input-group>
						</b-col>
					</td>
					<td>
						<b-form-textarea
							style="height: 40px;"
							id="textarea"
							v-model="lostItem['comments']"
							:placeholder="$t('comment')"
							rows="3"
							max-rows="6"
						></b-form-textarea>
					</td>
					<td class="text-center " >
						<i @click="trashFromItem(index)" class="fa fa-trash fa-lg "></i>
					</td>
				</tr>
			</table>

		</b-row>

		<div style="display: flex;justify-content: flex-end">
			<b-button @click="closeModal" style="margin-right: 10px;" variant="primary" size="sm">{{$t('cancel')}}
			</b-button>
			<b-button size="sm" variant="success" @click="createRequest">{{$t('save')}}</b-button>
		</div>
	</div>

</template>

<script>
import Multiselect from 'vue-multiselect'
import WhDocument from "../../../services/wh-document.service";
import {mapGetters, mapState} from 'vuex'
import ViewRequest from "./ViewRequest";
import UsersService from "../../../services/users.sevice";

export default {
		name: "createRequest",
		props: {
			departments: {
				type: Array,
				default: []
			},
			draftObject: {
				type: Object,
				default: {}
			},
			itemList: {
				type: Array,
				default: []
			}
		},
		components: {ViewRequest, Multiselect},
		data() {
			return {
				value: [],
				stats: null,
				isExeption: false,
				filter: {
					barCode: '',
					name: ''
				},
				transferPermittedDepartments: [],
				loader: false,
				viewModal: false,
				department: null,
				isCheckAll: false,
				checkedItems: [],
				}
		},
		methods: {
			async trashFromItem(index) {
				await this.$store.commit('warehouse/deleteFromItems', index);
				await this.getToDepInfo()
			},
			addItemForExeption: async function() {
				await this.$store.commit('warehouse/setItemsForExeption', this.checkedItems);
				await this.getToDepInfo()
			},
			async deleteItemForExeption() {
				await this.$store.commit('warehouse/deleteItemsForExeption', this.checkedItems);
				await this.getToDepInfo()
			},
			async getToDepInfo() {
				let array = [];
					for (let i = 0; i < this.itemsForModal.length; i++) {
						array.push(this.itemsForModal[i].itemId)
					}
					let payload = {}
					if (this.department) {
						payload.depId = this.department.id;
					}
					payload.itemIds = array;

					if (this.department) {
						this.loader = true;
						await WhDocument.requestWarehouse(payload).then(response => {
							 response.data.forEach(el => {
								this.itemsForModal.forEach(item => {
									if(el.itemId == item.itemId) {
										el.inventory = item.inventory
										el.count  = item.count
										el.comments = item.comments

									}
								})
							})
							this.$store.commit('warehouse/setItemsForModal', []);
							this.$store.commit('warehouse/setItemsForModal', response.data);
							this.loader = false;
						})
					}
			},
			checkAll: function (items) {
				this.isCheckAll = !this.isCheckAll;
				this.checkedItems = [];
				if (this.isCheckAll) { // Check all
					for (let i = 0; i < items.length; i++) {
						if(!items[i].isItemDublicate) {
							this.checkedItems.push(items[i])
						}
					}
				}


			},
			viewExeptions() {
				this.isExeption = !this.isExeption
			},
			async accept() {
				let str = "?depIds=" + this.fromDepId+
					"&catId=" + 65 +
					"&start=" + null +
					"&end=" + null +
					"&barcode=" + `${this.filter.barCode !== '' ? this.filter.barCode : null}` +
					"&name=" + `${this.filter.name !== '' ? this.filter.name : null}` +
					"&subId="+ null +
					"&sub2Id=" + null +
					"&sub3Id=" + null +
					"&genderId=" + null +
					"&brandId=" + null +
					"&colorId=" + null;
				let payload = {
					link:str,
					departments: {
						page:1,
						limit:20,
						depId: this.fromDepId
					}
				}
				let res = await WhDocument.lessThanFiveExeption(payload)
				if(res.data) {
					this.stats = res.data
					this.value = Object.values(this.stats)[0].items
				}

			},
			async loadWarehouse() {
				if (this.$can('get', 'permitted departments')) {
					UsersService.getPermittedDepartments().then(async response => {
						this.transferPermittedDepartments = await response.data.transferPermittedDepartments
					})
				}
			},
			viewItems() {
				let array = [];
				array = this.itemsForModal.map(item => {
					return item.itemId
				});

				WhDocument.viewWarehouseRequest(array).then(res => {
					this.$store.commit('warehouse/setViewRequestWarehouseModalItems', res.data);
				})
				this.viewModal = true;
			},
			closeModal() {
				this.$emit('closeModal', false);
			},
			createRequest() {
				let obj = {}
				obj.fromDepartment = parseInt(this.fromDepId)
				obj.status = 'SUSPENDED'
				let array = [];
				array = this.itemsForModal.map(item => {
					if (parseInt(item.count) > 0) {
						return {
							itemId: item.itemId,
							id: null,
							count: parseInt(item.count),
							comment: item.comments
						}
					} else {
						return {
							itemId: item.itemId,
							id: null,
							count: 0,
							comment: item.comments
						}
					}

				});
				obj.requestItem = array;
				obj.id = this.draftObject.id;
				obj.status = 'PENDING';
				if (this.department) {
					obj.toDepartment = this.department.id;
					WhDocument.requesWarehousetUpdate(obj).then(response => {
						if (response) {
							this.$vs.notify({
								title: 'Отправит заявку',
								color: 'success',
								icon: 'close',
								position: 'top-right'
							});
							this.$emit('closeModal', false);
							this.department = null;

						}
					})
				} else {
					this.$vs.notify({
						title: 'Пожалуйста выберите Отдел',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}

			}
		},

		computed: {
			...mapState(['isCashier','isAdmin']),
			checkSaleType() {
				if(Object.values(this.stats)[0]) {
					for(let i =0; i<this.myDepartments.length; i++) {
						if(Object.values(this.stats)[0].depId == this.myDepartments[i].id) {
								return this.myDepartments[i].saleType
						}
					}
				}
				// return JSON.parse(Object.values(this.stats)[0].depId)
			},
			...mapGetters('departments', [
				'myDepartments'
			]),
			...mapState('warehouse', [
				'itemsForModal'
			]),
			...mapState('departments', [
				'fromDepId'
			]),
			listWarehouse() {
				return this.transferPermittedDepartments.filter(item => {
					if(item.id == this.fromDepId || !item.saleType) {
							item.$isDisabled = true
					}else {
						item.$isDisabled = false
					}
					return item;
				})
			}
		},
		created() {
			this.loadWarehouse();

		},
		watch: {
			'checkedItems': {
				handler(newValue, oldValue) {
					if (newValue.length !== oldValue.length) {
						this.isCheckAll = false;
					}
					let itemPrice = Object.values(this.stats);
					if (itemPrice[0].items.length == newValue.length) {
						this.isCheckAll = true;
					}
				}
			},
			'department': {
				async handler(newValue) {
					await this.getToDepInfo()
				}

			}
		}
	}
</script>

<style scoped>
	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
	tr td {
		vertical-align: middle
	}
	.card {
  		 min-height: 3rem;
	}
	.card .card-body {
		padding: 10px
	}
	.ss {
		outline: 1px solid red;
	}
</style>
